import { useTranslation } from 'react-i18next';

import { generateInstructionsForUseLink, SUPPORT_URL } from '@configs';
import { DropdownMenu, IconGlobe } from '@ui-core';

import useAuthFooterService from './auth-footer.service';

export const AuthFooter: React.FC = () => {
  const { t } = useTranslation();

  const { selectedLanguage, setSelectedLanguage, languageList } =
    useAuthFooterService();

  return (
    <div className="caption-2 mb-8 mt-3 flex items-center justify-center gap-3 text-center text-primary-300">
      <span>
        <a
          href={SUPPORT_URL}
          target="_blank"
          rel="noreferrer"
          className="caption-2 text-primary-300"
        >
          {t('auth.footer.getHelp')}
        </a>
      </span>
      <span className="border-l border-r border-primary-300 px-3">
        <a
          href={generateInstructionsForUseLink()}
          target="_blank"
          rel="noreferrer"
          className="caption-2 text-primary-300"
        >
          {t('auth.footer.instructions')}
        </a>
      </span>
      <div className="flex items-center">
        <DropdownMenu
          options={languageList}
          selectedOption={selectedLanguage}
          setSelectedOption={setSelectedLanguage}
          variant="ghost"
          Icon={IconGlobe}
        />
      </div>
    </div>
  );
};
